import React, { useEffect } from "react";
import ButtonSKA from "../Buttons/ButtonSKA";
import strings from "../../helpers/Localization";
import Inputs from "../Inputs/Inputs";
import ButtonSkaRound from "../Buttons/ButtonSkaRound";

const Drawer = ({ open, hide, onClose, title, icon, fields, isValidationRed, isDisabledValidateButton, validationTitle, validationIcon, onValidate, children, heightBody }) => {
    const [isnull, setIsNull] = React.useState(!open);

    const delay = ms => new Promise(res => setTimeout(res, ms));

    React.useEffect(() => {
        async function waitAnimation() {
            await delay(333);
            setIsNull(true);
        }
        if (open) {
            setIsNull(false);
        }
        else {
            waitAnimation();
        }
    }, [open]);


    if (!isnull) {
        return <div className="modal" style={{ visibility: hide ? "hidden" : "visible" }}>
            <div className="modal-black-box" style={{ opacity: open ? "1" : "0" }}/>
            <div className="drawer-container" style={{ opacity: open ? "1" : "0", width: open ? "50%" : "0px" }}>
                <div className="drawer-paper" style={{ opacity: open ? "1" : "0" }}>
                    <div className="modal-header" style={{ backgroundColor: "var(--primary-light)" }}>
                        <ButtonSkaRound
                            type="secondary"
                            onClick={onClose}
                            nameIcon="closeicon"
                        />
                        <span>{title ? title : ""}</span>
                        <span style={{ flexGrow: "1" }}/>
                        {
                            onValidate ?
                                <ButtonSKA
                                    type={isValidationRed ? "red" : "primary-icon"}
                                    isDisabled={isDisabledValidateButton}
                                    onClick={onValidate}
                                    nameIcon={validationIcon ? validationIcon : "check"}
                                    text={validationTitle ? validationTitle : strings.startSearch}
                                /> : null
                        }
                    </div>
                    <div className="modal-body" style={{ width: "auto", height: heightBody ? heightBody : "calc(100% - 120px)", maxHeight: "calc(100% - 120px)", overflowY: "auto", overflowX: "hidden",
                        padding: "20px" }}>
                        {fields ? fields.map((item, index) => {
                            return <Inputs key={index} field={item}/>;
                        }) : null}
                        {children}
                    </div>
                </div>
            </div>
        </div>;
    }
};

export default Drawer;
